module.exports = __webpack_public_path__ + "static/media/pfSense_step1.1c0bc82d.png";